module.exports = __webpack_public_path__ + "img/t.80bbf42b.jpg";